import { Injectable, NgZone } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ApplicationInsights, DistributedTracingModes, ITelemetryItem, SeverityLevel } from '@microsoft/applicationinsights-web';
import { Location } from '@angular/common';

const domain = window.location.hostname;
const tenantId = domain.split('.')[0];
const telemetryInitializer = (envelope: ITelemetryItem): boolean | void => {
	envelope.tags['ai.cloud.role'] = 'MTPro Angular App';
	envelope.tags['ai.cloud.roleInstance'] = domain;
};

@Injectable({
	providedIn: 'root'
})
export class LoggerService {

	appInsights: ApplicationInsights;
	constructor(private _zone: NgZone) {

		this._zone.runOutsideAngular(() => {
			this.appInsights = new ApplicationInsights({
				config: {
					instrumentationKey: environment.instrumentationKey,
					distributedTracingMode: DistributedTracingModes.W3C,
					enableAutoRouteTracking: true,
					enableCorsCorrelation: true,
					maxAjaxCallsPerView: -1,
					correlationHeaderDomains: ['*.mapcom.com', domain],
					overridePageViewDuration: true,
				}
			});
			this.appInsights.snippet.queue.push(() => {
				this.appInsights.addTelemetryInitializer(telemetryInitializer);
			});
			this.appInsights.loadAppInsights();
			this.appInsights.trackPageView();
		});
	}

	clearAuthenticatedUserContext() {
		this._zone.runOutsideAngular(() => {
			this.appInsights.clearAuthenticatedUserContext();
		});
	}
	setAuthenticatedUserContext(userId: string) {
		this._zone.runOutsideAngular(() => {
			this.appInsights.setAuthenticatedUserContext(`${tenantId}${userId}`.replace(/[^A-Za-z0-9\-]/g, ''), null, true);
		});
	}
	logEvent(name: string, properties?: { [key: string]: any }) {
		this._zone.runOutsideAngular(() => {
			this.appInsights.trackEvent({ name }, properties);
		});
	}

	logMetric(name: string, average: number, properties?: { [key: string]: any }) {
		this._zone.runOutsideAngular(() => {
			this.appInsights.trackMetric({ name, average }, properties);
		});
	}

	logException(exception: Error, severityLevel: SeverityLevel | number = SeverityLevel.Error) {
		this._zone.runOutsideAngular(() => {
			this.appInsights.trackException({ exception, severityLevel });
		});
	}

	logTrace(message: string, properties?: { [key: string]: any }) {
		if (!environment.production) {
			this._zone.runOutsideAngular(() => {
				this.appInsights.trackTrace({ message }, properties);
			});
		}
	}

}
